import { Department } from "@/models/Department";

export const DepartmentRequest = (argDepartment) => {
  let department = argDepartment.copy();

  if (!department.id) {
    delete department.id;
  }

  for (var i = 0; i < department.persons.length; i++) {
    department.persons[i] = department.persons[i].id;
  }

  if (department.boss) {
    department.boss = department.boss.id;
  }

  if (department.company) {
    department.company = department.company.id;
  }

  if (department.safety_representative) {
    department.safety_representative = department.safety_representative.id;
  }

  if (department.parent) {
    department.parent = department.parent.id;
  }

  return department;
};

export const DepartmentResponse = (department) => {
  return new Department(department);
};

export const DepartmentsResponse = (departments) => {
  return departments.map((p) => DepartmentResponse(p));
};
